import { financeAPI, api } from "../../axios";

export const actions = {
  //OfficeBudgetItem
  GetOfficeBudgetItemByOffice(context, data) {
    return financeAPI.get(`DeliveryUnitBudgetItem/deliveryUnit/${data.id}?cycle=${data.cycle}`);
  },
  GetSingleOfficeBudgetItem(context, data) {
    return financeAPI.get(`DeliveryUnitBudgetItem/${data}`);
  },
  UpdateOfficeBudgetItem(context, data) {
    return financeAPI.put(`DeliveryUnitBudgetItem/${data.id}`, data);
  },
  DeleteOfficeBudgetItem(context, data) {
    return financeAPI.delete(`DeliveryUnitBudgetItem/${data}`);
  },
  CreateOfficeBudgetItem(context, data) {
    return financeAPI.post(`DeliveryUnitBudgetItem/Add`, data);
  },
  createMultipleDeliveryUnitBudgetItem(context, data) {
    return financeAPI.post(`DeliveryUnitBudgetItem/Add/Multiple`, data);
  },
  GetMyOfficeBudgetItem(context, data) {
    // return financeAPI.get(`DeliveryUnitBudgetItem/myDeliveryUnit/${data}`);
    return financeAPI.get(`DeliveryUnitBudgetItem/myDeliveryUnit/${data.cycle}/${data.deliveryUnitId}`);
  },
  GetMyOfficeBudgetItemSummary(context, data) {
    // return financeAPI.get(`DeliveryUnitBudgetItem/myDeliveryUnit/${data}`);
    return financeAPI.get(`DeliveryUnitBudgetItem/DeliveryUnit/Summary/${data.cycle}/${data.deliveryUnitId}`);
  },
  PostOfficeBudgetItem(context, data) {
    return financeAPI.put(`DeliveryUnitBudgetItem/post/${data}`);
  },

  postMultipleBudgetItems(context, data) {
    return financeAPI.put("DeliveryUnitBudgetItem/Post/Multiple", data);
  },

  GetOfficeBudgetItemByCampus(context, { campusId, cycle }) {
    return financeAPI.get(`DeliveryUnitBudgetItem/campus/${campusId}?cycle=${cycle}`);
  },

  /** Transaction */

  CreateOfficeBudgetItemTransaction(context, data) {
    return api.post("DeliveryUnitBudgetItemTransaction/Debit", data);
  },
  GetOfficeBudgetItemTransaction(context, data) {
    return api.get(`DeliveryUnitBudgetItemTransaction/DeliveryUnitBudgetItem/${data}`);
  },
  revertFunds(context, { transaction, revertOption }) {
    if (revertOption === "fs") {
      return financeAPI.post("DeliveryUnitBudgetItem/Return/FundSource", transaction);
    }
    if (revertOption === "oe") {
      return financeAPI.post("DeliveryUnitBudgetItem/Return", transaction);
    }
  },
};
